<template>
    <v-app>
        <v-card>
            <v-card-title class="headline mt-8 justify-center">
                Política de Privacidade — ZaperMenu
            </v-card-title>

            <v-card-text style="text-align: justify; padding: 24px 40px;">
                <div style="max-width: 700px; margin: auto;">
                    <p><strong>Última atualização:</strong> 27/09/2026</p>
                    <p>
                        A <strong>Scheeren Company LTDA</strong>, inscrita no CNPJ nº
                        50.515.044/0001-22, proprietária da marca <strong>ZaperMenu</strong>,
                        respeita a sua privacidade e está comprometida em proteger os seus dados
                        pessoais. Esta Política de Privacidade explica como coletamos, usamos e
                        protegemos as informações dos nossos usuários.
                    </p>

                    <v-divider class="my-3"/>

                    <h3>1. Informações que Coletamos</h3>
                    <div>Podemos coletar as seguintes informações:</div>
                    <ul>
                        <li>
                            Dados cadastrais: nome, e-mail, telefone/WhatsApp, nome do estabelecimento, endereço.
                        </li>
                        <li>
                            Dados de uso: pedidos realizados, preferências de cardápio, horários de acesso.
                        </li>
                        <li>
                            Informações técnicas: endereço IP, tipo de navegador, dispositivo e sistema operacional.
                        </li>
                        <li>
                            Dados de pagamento: apenas quando necessário para processar cobranças (por meio de parceiros de pagamento seguros).
                        </li>
                    </ul>

                    <v-divider class="my-3"/>

                    <h3>2. Como Utilizamos os Dados</h3>
                    <div>Os dados coletados podem ser usados para:</div>
                    <ul>
                        <li>Fornecer e operar nossos serviços.</li>
                        <li>Processar pedidos e pagamentos.</li>
                        <li>Enviar comunicações importantes sobre o uso do sistema.</li>
                        <li>Oferecer suporte e atendimento.</li>
                        <li>Melhorar a experiência do usuário.</li>
                        <li>Enviar ofertas, promoções e conteúdos relevantes (com seu consentimento).</li>
                        <li>Medir o resultado dos nossos anúncios, para saber quais campanhas trazem cadastros e clientes.</li>
                    </ul>

                    <v-divider class="my-3"/>

                    <h3>3. Compartilhamento de Informações</h3>
                    <p>
                        O ZaperMenu <strong>não vende</strong> dados pessoais. Podemos
                        compartilhar informações com:
                    </p>
                    <ul>
                        <li>Prestadores de serviço essenciais para operação (pagamentos, hospedagem, suporte técnico).</li>
                        <li>Autoridades legais, quando exigido por lei.</li>
                        <li>Parceiros de marketing apenas com autorização do usuário.</li>
                        <li>
                            Plataformas de anúncios, como a Meta (Facebook e Instagram), para medir o
                            resultado das nossas campanhas. Informamos quando alguém se cadastra no nosso
                            site, cria uma conta ou contrata um plano (com o valor da primeira fatura),
                            junto com telefone, e-mail e nome em formato criptografado (hash), o endereço
                            IP, o navegador e os identificadores de clique em anúncio gravados nos cookies.
                            A plataforma usa essas informações para relacionar o cadastro ao anúncio que o
                            originou e para otimizar a entrega das campanhas.
                        </li>
                    </ul>

                    <v-divider class="my-3"/>

                    <h3>4. Armazenamento e Segurança</h3>
                    <ul>
                        <li>Utilizamos criptografia e protocolos seguros para proteger suas informações.</li>
                        <li>Os dados são armazenados em servidores seguros no Brasil e/ou no exterior.</li>
                        <li>Somente colaboradores autorizados têm acesso às informações.</li>
                    </ul>

                    <v-divider class="my-3"/>

                    <h3>5. Direitos do Usuário</h3>
                    <div>Conforme a LGPD (Lei nº 13.709/2018), você pode:</div>

                    <ul>
                        <li>Solicitar acesso aos seus dados.</li>
                        <li>Solicitar correção ou atualização.</li>
                        <li>Solicitar exclusão de dados.</li>
                        <li>Revogar consentimento para uso de informações.</li>
                    </ul>
                    <div>Para exercer seus direitos, envie uma solicitação para contato@zapermenu.com.br.</div>

                    <v-divider class="my-3"/>

                    <h3>6. Cookies</h3>
                    <p>
                        Usamos cookies para lembrar preferências, melhorar navegação e analisar
                        uso. Você pode desativar no navegador, mas isso pode limitar recursos.
                    </p>
                    <p>
                        No nosso site também usamos cookies de medição de anúncios da Meta e do Google,
                        que registram de qual anúncio você veio. Você pode bloqueá-los no navegador e
                        ajustar o uso dos seus dados em anúncios nas configurações da sua conta da Meta
                        e do Google.
                    </p>

                    <v-divider class="my-3"/>

                    <h3>7. Alterações</h3>
                    <p>Podemos atualizar esta Política de Privacidade periodicamente. A versão mais recente estará sempre disponível no site e no aplicativo.</p>

                    <v-divider class="my-3"/>

                    <h3>8. Contato</h3>
                    <p>
                        E-mail: contato@zapermenu.com.br<br />
                        WhatsApp: (49) 9 8895-1210<br />
                        Endereço: Avenida Brasília, nº 1933, Centro, Pinhalzinho/SC – CEP
                        89870-000
                    </p>
                </div>
            </v-card-text>
        </v-card>
    </v-app>
</template>

<script>
export default {
    name: 'PoliticaPrivacidade',
};
</script>
